import {CustomOverlayData} from "../types/overlay";

// Utility to generate a color string (hsl)
const BRIGHT_COLORS = [
  "#3C71C0",
  "#FADC00",
  "#00FFFF", // cyan
  "#39FF14", // neon green
  "#FFFF00", // yellow
  "#FF00FF", // magenta
  "#1E90FF", // dodger blue
  "#FF4500", // orange-red
  "#00FF7F", // spring green
];

// Generate a color based on search list index
const generateColor = (index: number) =>
  BRIGHT_COLORS[index % BRIGHT_COLORS.length];  // Account for our index starting at 1

export const customOverlayLabel = (index: number) => `Gene List #${index + 1}`;

export function emptyCustomOverlayData(id: number): CustomOverlayData {
  return {
    id: id,
    name: customOverlayLabel(id),
    genes: "",
    parsedGenes: [],
    colour: generateColor(id)
  }
}

export function isOverlayFormDataValid(customOverlayLists: CustomOverlayData[]) {
  return customOverlayLists.length > 0 && customOverlayLists.every(list => list.parsedGenes.length > 2);
}
